/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Open_LeadInputs */

const en_us2_workout_open_lead = /** @type {(inputs: Workout_Open_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It was started on another device. Continue it here, or end it and start a new one.`)
};

const pt_br2_workout_open_lead = /** @type {(inputs: Workout_Open_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ele foi iniciado em outro aparelho. Continue aqui, ou encerre e comece um novo.`)
};

const es_419_workout_open_lead = /** @type {(inputs: Workout_Open_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se empezó en otro dispositivo. Continúalo aquí, o termínalo y empieza uno nuevo.`)
};

const pt_pt2_workout_open_lead = /** @type {(inputs: Workout_Open_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foi iniciado noutro dispositivo. Continua aqui, ou termina-o e começa um novo.`)
};

const fr_fr2_workout_open_lead = /** @type {(inputs: Workout_Open_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elle a été commencée sur un autre appareil. Continue-la ici, ou termine-la et commences-en une nouvelle.`)
};

const de_de2_workout_open_lead = /** @type {(inputs: Workout_Open_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es wurde auf einem anderen Gerät gestartet. Setz es hier fort oder beende es und starte ein neues.`)
};

const it_it2_workout_open_lead = /** @type {(inputs: Workout_Open_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`È stato iniziato su un altro dispositivo. Continualo qui, oppure terminalo e iniziane uno nuovo.`)
};

/**
* | output |
* | --- |
* | "It was started on another device. Continue it here, or end it and start a new one." |
*
* @param {Workout_Open_LeadInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_open_lead = /** @type {((inputs?: Workout_Open_LeadInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Open_LeadInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_open_lead(inputs)
	if (locale === "es-419") return es_419_workout_open_lead(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_open_lead(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_open_lead(inputs)
	if (locale === "de-DE") return de_de2_workout_open_lead(inputs)
	if (locale === "it-IT") return it_it2_workout_open_lead(inputs)
	return en_us2_workout_open_lead(inputs)
});
export { workout_open_lead as "workout.open_lead" }